module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? [_c('pl-spinner', {
    staticClass: "x2 mt10",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "200px"
    }
  })] : [_c('div', {
    staticClass: "row col-xs no-padding no-margin justify-end"
  }, [(_vm.hasAdminAdminPermission) ? _c('pl-button', {
    staticClass: "remove-selected-users pl-ruby",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "disabled": _vm.selectedUsers.length < 1
    },
    nativeOn: {
      "click": function($event) {
        _vm.selectedUsers.length > 1 ?
          _vm.removeSelectedUsers() :
          _vm.removeUserFromTable(_vm.selectedUsers[0])
      }
    }
  }, [_vm._v("\n        Remove Selected Users\n      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.usersToShow) ? _c('table', {
    staticClass: "users-table mt3 w-100"
  }, [_c('thead', [_c('tr', {
    staticClass: "row"
  }, [(_vm.hasAdminAdminPermission) ? _c('td', {
    staticClass: "col-xs-1 b"
  }, [(!_vm.show_trial_teachers) ? _c('pl-checkbox', {
    staticClass: "col-xs-1",
    on: {
      "change": _vm.selectAll
    },
    model: {
      value: (_vm.allSelected),
      callback: function($$v) {
        _vm.allSelected = $$v
      },
      expression: "allSelected"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 b"
  }, [_vm._v("Name")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 b"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-1 b",
    staticStyle: {
      "padding-left": "7px"
    }
  }, [_vm._v("Role")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 b"
  }, [_vm._v("School")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-1 b"
  }, [_vm._v("RTs")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-1 b"
  }, [_vm._v("Type")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 b"
  }, [_vm._v("Last Active")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-1 b"
  }), _vm._v(" "), _c('td', {
    staticClass: "col-xs-1 b"
  })])]), _vm._v(" "), (_vm.usersToShow.length > 0 && !_vm.loadingTable) ? _c('tbody', {
    attrs: {
      "id": "admin-view-users-table"
    },
    on: {
      "scroll": function($event) {
        return _vm.$emit('scroll-on-table')
      }
    }
  }, _vm._l((_vm.usersToShow), function(user, index) {
    return _c('tr', {
      key: index,
      staticClass: "row"
    }, [_c('td', {
      staticClass: "col-xs-1"
    }, [(user.id !== _vm.getProfile.id) ? _c('pl-checkbox', {
      staticClass: "col-xs-1",
      attrs: {
        "id": user.id
      },
      on: {
        "change": _vm.checkAllSelected
      },
      model: {
        value: (user.selected),
        callback: function($$v) {
          _vm.$set(user, "selected", $$v)
        },
        expression: "user.selected"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2 flex items-center"
    }, [_c('div', {
      staticClass: "avatar-circle avatar-size mr2 clickable",
      style: ({
        backgroundImage: 'url(' + user.avatar_url + ')',
        'background-size': 'cover',
        'background-position': 'center',
      }),
      on: {
        "click": function($event) {
          return _vm.openUserDetails(user)
        }
      }
    }), _vm._v(" "), (user.role === 'teacher') ? _c('span', {
      staticClass: "name-cell cursor-pointer truncate",
      attrs: {
        "title": user.name
      },
      on: {
        "click": function($event) {
          return _vm.openUserDetails(user)
        }
      }
    }, [_vm._v("\n              " + _vm._s(user.name) + "\n            ")]) : _c('span', {
      staticClass: "cursor-pointer truncate",
      attrs: {
        "title": user.name
      },
      on: {
        "click": function($event) {
          return _vm.openUserDetails(user)
        }
      }
    }, [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2 email-cell",
      attrs: {
        "title": user.email
      }
    }, [_vm._v("\n            " + _vm._s(user.email) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-1 no-padding"
    }, [_c('span', [_vm._v(_vm._s(user.role) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2"
    }, [_vm._v("\n            " + _vm._s(user.school_name) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-1"
    }, [_vm._v(_vm._s(user.rts_count))]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-1"
    }, [_vm._v(_vm._s(user.type))]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-1"
    }, [_vm._v(_vm._s(user.last_active))]), _vm._v(" "), [(_vm.hasAdminAdminPermission && user.id !== _vm.getProfile.id) ? _c('td', {
      staticClass: "col-xs-1"
    }, [_c('pl-menu', {
      attrs: {
        "menuSize": 3,
        "direction": "right"
      }
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('li', {
      staticStyle: {
        "color": "#e53935"
      },
      on: {
        "click": function($event) {
          return _vm.removeUserFromTable(user)
        }
      }
    }, [_vm._v("\n                    Remove User\n                    "), _c('i', {
      staticClass: "fas fa-trash-alt",
      staticStyle: {
        "color": "#e53935"
      }
    })])])], 1)], 1) : _vm._e()]], 2)
  }), 0) : (_vm.usersToShow.length == 0) ? _c('div', {
    staticClass: "center-xs b no-users-style"
  }, [_vm._v("\n        No Users.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.loadingTable) ? _c('div', {
    key: "loading",
    staticClass: "flex center-xs middle-xs h-inherit"
  }, [_c('pl-spinner')], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show_remove_user_confirmation) ? _c('dialog-delete-confirm', {
    attrs: {
      "subHeader": _vm.contentMessageToRemove,
      "header": _vm.headerToRemoveUsers
    },
    on: {
      "close": function($event) {
        _vm.show_remove_user_confirmation = false
      },
      "actionConfirmed": _vm.removeUsersCallService
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_remove_teachers_confirmation) ? _c('dialog-delete-teachers-confirm', {
    attrs: {
      "subHeader": _vm.contentMessageToRemove,
      "optionalText": _vm.headerToRemoveUsers,
      "teachersToRemove": _vm.teachersToRemove
    },
    on: {
      "close": function($event) {
        _vm.show_remove_teachers_confirmation = false
      },
      "actionConfirmed": _vm.removeUsersCallService
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userDetailsID) ? _c('user-details-modal', {
    attrs: {
      "userId": _vm.userDetailsID,
      "userSchool": _vm.userSchool,
      "systemWide": true
    },
    on: {
      "close": function($event) {
        _vm.userDetailsID = ''
      }
    }
  }) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5fde3360!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/adminPortalParlay/adminPortalParlayUsers/adminViewUsersTable.vue
// module id = 2188
// module chunks = 61